export default __webpack_public_path__ + "static/media/wallet.4e545f51.png";